import { Controller } from "@hotwired/stimulus";

// The toggle is either Administrate's checkbox or a ui--switch's hidden input (value "true"/"false").
export default class extends Controller {
  static targets = ["toggle", "input"];

  connect() {
    this.updateValue();
  }

  toggleInput() {
    this.inputTarget.disabled = !this.enabled;
    this.updateValue();
  }

  updateValue() {
    if (this.enabled) {
      this.inputTarget.setAttribute("required", "");
    } else {
      this.inputTarget.removeAttribute("required");
      this.inputTarget.value = null;
    }
  }

  get enabled() {
    const toggle = this.toggleTarget;
    return toggle.type === "checkbox" ? toggle.checked : toggle.value === "true";
  }
}
